import { createRouter, createWebHistory } from 'vue-router'
import store from '../store/index'
import SeperateView from '../views/SeperateView.vue'
import LoginView from '../components/common/LoginComponent.vue'

// user 계정 관리
import SchoolManage from '../components/userAccountManage/schoolManage/SchoolManageComponent.vue'
import SchoolManageDetail from '../components/userAccountManage/schoolManage/schoolDetail/SchoolDetailComponent.vue'
import AccountIssue from '../components/userAccountManage/accountIssue/UserIdManageComponent.vue'
import NlpAccountCreate from '../components/userAccountManage/accountIssue/NlpAccountCreate.vue'
import AccountSettingSend from '../components/userAccountManage/accountSettingSend/AccountSettingSendView.vue'
import AddTransferStudent from '../components/userAccountManage/addTransferStudent/AddTransferStudentComponent.vue'

// guest 계정 관리
import GuestManage from '../components/guestAccountManage/addModifyGuest/GuestManageView.vue'
import GuestDetail from '../components/guestAccountManage/addModifyGuest/guestSchoolDetail/GuestSchoolDetailComponent.vue'
import FreeApplication from '../components/guestAccountManage/freeExperienceApplication/FreeExperienceView.vue'
import FreeApplicationManual from '../components/guestAccountManage/freeExperienceApplication/FreeExperienceManualView.vue'
import TeacherTrain from '../components/guestAccountManage/teacherTrainAccount/TeacherTrainAccountView.vue'
import IssueGeneralAccount from '../components/guestAccountManage/issueGeneralAccount/IssueGeneralAccountView.vue'

// 견적 발급
import Estimate from '../components/estimate/EstimateComponent.vue'

// 사용 현황
import UsageStatus from '../components/usageStatus/UsageStatusView.vue'

// 학교 조회
import SchoolBrowse from '../components/schoolBrowse/SchoolBrowseView.vue'

// 연락처
// import contact from '../components/contact/ContactManage.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: SeperateView
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },

  // user 계정관리
  // 학교 등록 / 수정
  {
    path: '/user/school-manage',
    name: 'school-manage',
    component: SchoolManage,
    meta: {
      auth: true,
      num: 1
    }
  },

  // 학교 등록 / 수정 상세 정보
  {
    path: '/user/school-manage/:code',
    name: 'manage-id',
    component: SchoolManageDetail,
    meta: {
      auth: true,
      num: 1
    }
  },

  // 계정 발급
  {
    path: '/user/account-issue',
    name: 'account-issue',
    component: AccountIssue,
    meta: {
      auth: true,
      num: 2
    }
  },

  // 자연어 계정 발급
  {
    path: '/user/nlp-account-create',
    name: 'nlp-account-create',
    component: NlpAccountCreate,
    meta: {
      auth: true,
      num: 11
    }
  },

  // 계정 세팅 / 전달
  {
    path: '/user/account-setting-send',
    name: 'account-setting-send',
    component: AccountSettingSend,
    meta: {
      auth: true,
      num: 3
    }
  },

  // 전학생 추가발급
  {
    path: '/user/add-transfer-student',
    name: 'add-transfer-student',
    component: AddTransferStudent,
    meta: {
      auth: true,
      num: 4
    }
  },

  // guest 계정관리
  // guest 등록 / 수정
  {
    path: '/guest/guest-manage',
    name: 'guest-manage',
    component: GuestManage,
    meta: {
      auth: true,
      num: 5
    }
  },
  // guest 등록 / 수정 상세 정보
  {
    path: '/guest/guest-manage/:schoolCode',
    name: 'guest-manage-id',
    component: GuestDetail,
    props: true,
    meta: {
      auth: true,
      num: 5
    }
  },
  // 무료체험 신청 자동 처리
  {
    path: '/guest/free-application',
    name: 'free-application',
    component: FreeApplication,
    meta: {
      auth: true,
      num: 6
    }
  },
  // 무료체험 신청 수동 처리
  {
    path: '/guest/free-application-manual',
    name: 'free-application-manual',
    component: FreeApplicationManual,
    meta: {
      auth: true,
      num: 9
    }
  },
  // 교사연수계정 발급
  {
    path: '/guest/teacher-train',
    name: 'teacher-train',
    component: TeacherTrain,
    meta: {
      auth: true,
      num: 7
    }
  },
  // 일반계정 발급
  {
    path: '/guest/issue-general-account',
    name: 'issue-general-account',
    component: IssueGeneralAccount,
    meta: {
      auth: true,
      num: 8
    }
  },

  // 견적발급
  // {
  //   path: '/contact',
  //   name: 'contact',
  //   component: contact,
  //   meta: {
  //     auth: true,
  //     num: 10
  //   }
  // },
  // 연락처
  {
    path: '/estimate',
    name: 'estimate',
    component: Estimate,
    meta: {
      auth: true,
      num: 9
    }
  },

  // 사용 현황 — 계정 발급 후 실제 접속 현황
  {
    path: '/usage-status',
    name: 'usage-status',
    component: UsageStatus,
    meta: {
      auth: true,
      num: 12
    }
  },

  // 학교 조회 — 분류(유료/무료/연수/서포터즈/AI미래교육연구회/박람회)별 학교 목록
  {
    path: '/school-browse/:category?',
    name: 'school-browse',
    component: SchoolBrowse,
    meta: {
      auth: true,
      num: 13
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 직전 라우트의 path — 목록 화면들이 "상세 페이지에서 뒤로가기로 돌아온 것인지"
// 판단하는 데 사용한다(새로고침/다른 탭 이동과 구분하기 위함). 새로고침하면
// 이 값은 초기화되므로 별도 처리가 필요 없다.
let lastFromPath = null
export const getLastFromPath = () => lastFromPath

router.beforeEach((to, from, next) => {
  if (to.meta.auth && !store.getters.logCheck) {
    next('/login')
    return
  }
  lastFromPath = from.path
  next()
})

export default router
